module.exports = __webpack_public_path__ + "img/bird.a963fd2b.png";